import {ElementRef, Injectable} from '@angular/core';
import * as Msal from 'msal';
import {ErrorCodes} from 'msal/lib-commonjs/Constants';
import {environment} from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AadB2CHelper {
    /*
    * B2C SignIn SignUp Policy Configuration
    */
    private clientApplication: Msal.UserAgentApplication;

    private static didUserCancel(errorMessage: string) {
        const errorMessageSplitCharacter = '|';
        if (errorMessage && errorMessage.includes(errorMessageSplitCharacter)) {
            const errorCode = errorMessage.split(errorMessageSplitCharacter);
            return errorCode[0] === ErrorCodes.userCancelledError;
        }

        return false;
    }

    public setClientApplication(): void {
        this.clientApplication = environment.useAadB2C
            ? new Msal.UserAgentApplication(
                environment.aadB2CConfig.clientID,
                // Configure the authority for Azure AD B2C
                `https://${environment.aadB2CConfig.authorityHost}/tfp/${environment.aadB2CConfig.tenant}/${environment.aadB2CConfig.signUpSignInPolicy}`,
                (errorDesc: any, token: any, error: any, tokenType: any) => {
                    // Called after loginRedirect or acquireTokenPopup
                },
                {
                    validateAuthority: false,
                    navigateToLoginRequestUrl: false,
                    redirectUri: environment.aadB2CConfig.redirectUri
                }
            )
            : null;
    }

    public login(): Promise<string> {
      const approot = document.getElementsByTagName('app-root')[0];
      let b2cLang = 'en';
      if (approot && approot.getAttribute('language') === 'de') {
        b2cLang = 'de';
      }
      return this.clientApplication
            .loginPopup(environment.aadB2CConfig.b2cScopes, `ui_locales=${b2cLang}`)
            .then(() => this.clientApplication.acquireTokenSilent(environment.aadB2CConfig.b2cScopes))
            .catch((error) => {
                const errorMessage = error as string;
                if (!AadB2CHelper.didUserCancel(errorMessage)) {
                    console.error('Error occurred during acquiring token silently: ' + errorMessage);
                    if (error.indexOf('AADB2C90118') > -1) {
                    this.clientApplication.authority = `https://${environment.aadB2CConfig.authorityHost}/tfp/${environment.aadB2CConfig.tenant}/${environment.aadB2CConfig.passwordResetPolicy}`;
                    this.clientApplication.loginPopup(environment.aadB2CConfig.b2cScopes, `ui_locales=${b2cLang}`)
                      .then((accessToken) => {
                        this.clientApplication.authority = `https://${environment.aadB2CConfig.authorityHost}/tfp/${environment.aadB2CConfig.tenant}/${environment.aadB2CConfig.signUpSignInPolicy}`;
                        return this.logout();
                      }, (err) => {
                        console.error(err);
                        this.clientApplication.authority = `https://${environment.aadB2CConfig.authorityHost}/tfp/${environment.aadB2CConfig.tenant}/${environment.aadB2CConfig.signUpSignInPolicy}`;
                      });

                  }

                    // try to send interactive request since AcquireTokenSilent failed
                    return this.clientApplication.acquireTokenPopup(environment.aadB2CConfig.b2cScopes);
                }
            });
    }

    public logout(): void {
        this.clientApplication.logout();
    }

    public aquireToken(): Promise<string> {
        if (this.clientApplication) {
            return this.clientApplication
                .acquireTokenSilent(environment.aadB2CConfig.b2cScopes)
                .catch(() => this.clientApplication.acquireTokenPopup(environment.aadB2CConfig.b2cScopes));
        }
        console.warn('empty token');
        return new Promise<string>((resolve) => {
            resolve('');
        });
    }

    public aquireTokenSilent(): Promise<string> {
        if (this.clientApplication) {
            return this.clientApplication.acquireTokenSilent(environment.aadB2CConfig.b2cScopes);
        }
        return new Promise<string>((resolve) => {
            resolve('');
        });
    }
}
